


















































































import {ScrollButton} from "wings-ui-components";
import { Component } from "vue-property-decorator";
import { ManagementServicesItem } from "@/store/mail_notify/management_services/types";
import { Getter } from "vuex-class";
import BaseItemsPage from "@/pages/Pages/BaseItemsPage";
import MNManagementServicesFilter from "@/components/MailNotify/ServiceManagement/MNManagementServicesFilter.vue";

@Component({ components: {MNManagementServicesFilter, ScrollButton } })
export default class MNManagementServices extends BaseItemsPage<ManagementServicesItem> {

  @Getter("managementServices") managementServicesResponse: any;

  private is_show_filter = false;
  tableFields = ['mn_service_name', 'service_provider', 'status', 'description'];

  getData(): any {
    return this.managementServicesResponse;
  }
}
